<template>
  <div :class="`padding-0 flex-start-start ${rowClass}`" @click="click">
    <span :class="`margin-left-8 color-${colorClass}`">
      <mdicon name="circle" size="16" />
    </span>
    <span class="flex-start">
      <span class="font-size-16 color-complementary-400">
        {{ caption }}
      </span>
      <DropdownModal
        v-if="code"
        class="margin-x-8"
        :modalWidth="100"
        modalClass="right-0 top-26 box-shadow--modal"
      >
        <template #click-area>
          <span class="color-complementary-200 cursor--pointer">
            <mdicon name="help-circle-outline" size="24" />
          </span>
        </template>
        <template #content>
          <div>
            <div
              class="font-size-16 font-weight-500 color-complementary-400 margin-bottom-4"
            >
              {{ $lang.indicatorCode }}
            </div>
            <div class="font-size-14 color-complementary-300 text-justify">
              {{ code }}
            </div>
          </div>
        </template>
      </DropdownModal>
    </span>
  </div>
</template>

<script>
import { DropdownModal } from "@/components/re-design";
import { computed, toRefs } from "vue";
export default {
  components: { DropdownModal },
  props: {
    rowClass: {
      type: String,
      default: "",
    },
    indicatorType: {
      type: Number,
      default: 1,
    },
    caption: {
      type: String,
      default: "",
    },
    code: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { rowClass, indicatorType, caption, code } = toRefs(props);

    const click = () => emit("click");

    const colorClass = computed(() =>
      indicatorType.value >= 1 ? "success" : "error"
    );

    // return data to be used in template
    return { rowClass, caption, code, colorClass, click };
  },
};
</script>
